<template>
  <service :image="image" :title="title" data-aos="fade">
    <h1 class="hidden">{{title}}</h1>
    <p>If you are looking for an alternative to processed snacks, I have a selection of delicious treats available
      to order for collection in Hertford, Hertfordshire. Using only good quality and 100% organic ingredients,
      they are free from refined sugar, refined flours and artificial flavours making them totally guilt-free
      and ever so tasty!
    </p>
    <p>To request the pricing list, please
      <contact-link :subject="title"></contact-link>.
    </p>
  </service>
</template>

<script>
import ContactLink from '@/components/ContactLink'
import Service from '@/components/Service'
import MetaInfoBuilder from '@/utils/social'

export default {
  components: {
    ContactLink,
    Service,
  },
  data: () => ({
    image: require(`@/assets/images/healthy-snacks-orders.jpg?vuetify-preload`),
    title: 'Healthy Snacks Orders',
  }),
  metaInfo() {
    return new MetaInfoBuilder()
      .description(this.title)
      .image(`${window.location.origin}${this.image.src}`)
      .title(this.title)
      .build()
  }
}
</script>

<style scoped>
h1 {
  color: #0096FF;
}
</style>
